export default class WelcomeScreenInfo {
  constructor(props) {
    var _props$description, _props$logoUrl, _props$showWelcomeScr, _props$title, _props$useCompanyLogo;
    this.description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : null;
    this.logoUrl = (_props$logoUrl = props === null || props === void 0 ? void 0 : props.logoUrl) !== null && _props$logoUrl !== void 0 ? _props$logoUrl : null;
    this.showWelcomeScreen = (_props$showWelcomeScr = props === null || props === void 0 ? void 0 : props.showWelcomeScreen) !== null && _props$showWelcomeScr !== void 0 ? _props$showWelcomeScr : false;
    this.title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : null;
    this.useCompanyLogo = (_props$useCompanyLogo = props === null || props === void 0 ? void 0 : props.useCompanyLogo) !== null && _props$useCompanyLogo !== void 0 ? _props$useCompanyLogo : false;
  }
  static from(json) {
    return new WelcomeScreenInfo(json);
  }
}

/** @deprecated Use WelcomeScreenInfo directly */

export function createWelcomeScreenInfo(json) {
  return new WelcomeScreenInfo(json);
}